import type { ProgramId, V4HSiteId } from "@/data/common/ids";

import { SubprogramsByApplianceCategory } from "@/domains/v4b/program/subprogram.types";

export type ProgramType = "DEFAULT" | "SITE";

export type ProgramColorName = "BLUE" | "GREEN" | "ORANGE" | "RED" | "PURPLE";
export const defaultProgramColorName: ProgramColorName = "BLUE";

export enum EProgramApplianceCategory {
  AC_UNIT_NON_INFRARED = "AC_UNIT_NON_INFRARED",
  AIR_HANDLING_UNIT = "AIR_HANDLING_UNIT",
  BOILER = "BOILER",
  CHARGING_STATION = "CHARGING_STATION",
  CHILLER = "CHILLER",
  CHILLER_FOOD_GRADE = "CHILLER_FOOD_GRADE",
  GENERATOR_SET = "GENERATOR_SET",
  HEATER = "HEATER",
  HEATER_STORAGE = "HEATER_STORAGE",
  HEATER_UNIT = "HEATER_UNIT",
  HEATING_FLOOR = "HEATING_FLOOR",
  HEAT_PUMP = "HEAT_PUMP",
  HEAT_PUMP_DHW = "HEAT_PUMP_DHW",
  HEAT_PUMP_WITH_TEMPERATURE = "HEAT_PUMP_WITH_TEMPERATURE",
  POOL_HEATER = "POOL_HEATER",
  PUMP_MOTOR = "PUMP_MOTOR",
  RADIANT_CEILING_PANEL = "RADIANT_CEILING_PANEL",
  WATER_HEATER = "WATER_HEATER",
  BOOKABLE_SPACE = "BOOKABLE_SPACE",
}

export interface Program {
  id: ProgramId;
  name: string;
  frontDisplayColor: ProgramColorName;
}

export interface SiteProgramOverview extends Program {
  siteId: V4HSiteId;
  programType: ProgramType;
  isActive: boolean;
  isSiteDefault: boolean;
}

export interface ProgramDetails {
  id: ProgramId;
  name: string;
  siteId: V4HSiteId;
  isSiteDefault: boolean;
  frontDisplayColor: ProgramColorName;
  subprograms: SubprogramsByApplianceCategory;
}
